import React from 'react'
import bindAll from 'lodash/bindAll'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import $ from 'jquery'
import { UilClipboardAlt, UilClockThree, UilDesktop, UilRuler, UilEnglishToChinese } from '@iconscout/react-unicons'

import FooterNew from '../../partials/FooterNew'
import HeaderNewClear from '../../partials/HeaderNewClear'
import ModalRegister from '../../partials/ModalRegister'
import ModalTry from '../../partials/ModalTry'
import _axios from '../../../dependencies/_axios'
import{
  assessmentFetchData,
  assessmentGetDetail,
  assessmentFetchDetail
} from '../../../actions/assessments'

type Props = {
	assessmentId: String,
	assessment: Map<string, any>,
	assessmentFilterData: Map<string, any>,
	assessmentFetchData: Function,
	assessmentGetDetail: Function,
	assessmentFetchDetail: Function,
};

class AssessmentDetail extends React.Component<Props>{
	constructor(props){
		super(props)

		this.state = {
			isModalOpen: false,
			isTryModalOpen: false,
			currentQuestionIndex: 0
		}

		bindAll(this, [
			'openModal',
			'closeModal',
			'openTryModal',
			'closeTryModal',
			'handleNextQuestion',
			'handlePrevQuestion',
			'handleSaveAnswer',
			'uploadRecordedVideo'
		])
	}

	componentDidMount(){
		this.props.assessmentGetDetail(this.props.assessmentId, {})
		window.scrollTo(0,0)
	}

	openModal() {
		this.setState({ isModalOpen: true })
	}

	closeModal() {
		this.setState({ isModalOpen: false })
	}

	openTryModal() {
		this.setState({ isTryModalOpen: true, currentQuestionIndex: 0 })
	}

	closeTryModal() {
		const { assessment } = this.props
		let sampleQuestions = assessment.get('sample_questions') ? assessment.get('sample_questions').toJS() : []
		sampleQuestions.map((question, index) => {
			delete question.user_answer
			return question
		})
		let new_assessment = assessment.toJS()
		new_assessment.sample_questions = sampleQuestions
		this.props.assessmentFetchDetail(new_assessment)
		this.setState({ isTryModalOpen: false, currentQuestionIndex: 0 })
	}


	handleNextQuestion(e, questionId) {
		if(this.state.currentQuestionIndex < this.props.assessment.get('sample_questions').size - 1){
			this.setState({ currentQuestionIndex: this.state.currentQuestionIndex + 1 })
		}else{
			this.closeTryModal()
			this.openModal()
		}
	}

	handlePrevQuestion(e, questionId) {
		if(this.state.currentQuestionIndex > 0){
			this.setState({ currentQuestionIndex: this.state.currentQuestionIndex - 1 })
		}
	}

	handleSaveAnswer(e, idx, questionId, type, answer) {
		console.log(`SAVE ANSWER : ${type}`, answer);
		const { globalGetLanguages, assessment } = this.props
		if(type === 'video'){
			this.uploadRecordedVideo(idx, answer)
		}else{
			let sampleQuestions = assessment.get('sample_questions') ? assessment.get('sample_questions').toJS() : []
			sampleQuestions.map((question, index) => {
				if (index === idx) {
					question.user_answer = answer
				}
				return question
			})
			let new_assessment = assessment.toJS()
			new_assessment.sample_questions = sampleQuestions
			this.props.assessmentFetchDetail(new_assessment)
		}

	}

	uploadRecordedVideo(idx,e){
		const { globalGetLanguages, assessment } = this.props
		const file = e
		const formData = new FormData();
    	formData.append('file',file)
    	formData.append('is_try_assessment',true)
		return _axios({
			url: `/companies/0/multi_document_save`,
			timeout: 200000,
			method: 'post',
			data: formData,
		}).then((response) => {
			const fileresponse=response.data
			console.log('success', fileresponse)
			let sampleQuestions = assessment.get('sample_questions') ? assessment.get('sample_questions').toJS() : []
			sampleQuestions.map((question, index) => {
				if (index === idx) {
					question.user_answer = fileresponse.fileurl
				}
				return question
			})
			let new_assessment = assessment.toJS()
			new_assessment.sample_questions = sampleQuestions
			this.props.assessmentFetchDetail(new_assessment)
		})
		.catch((error) => {
			console.log('fail', error)
			return null
		})
	}

	render(){
		const { globalGetLanguages, assessment } = this.props
		console.log('ASSESSMENT', assessment.toJS());
		let sampleQuestions = assessment.get('sample_questions') ? assessment.get('sample_questions') : []
		let question = sampleQuestions.size > 0 ? sampleQuestions.get(this.state.currentQuestionIndex) : null
		return (
			<div id='assessment-detail'>
				<HeaderNewClear isOnStatusLogo="is-on" />
				<section className="assessment-detail">
					<div className="ban-text">
						<h1>{assessment.get('title')}</h1>
						<div className={`row ${assessment.get('id') ? '' : 'hide'}`}>
							<div className='col-md-8'>
								<div className="detail-card">
									<h2>About This Test</h2>
									<p>{assessment.get('description')}</p>
								</div>
								<div className="detail-card">
									<h2>Measured Capabilities</h2>
									<p>{assessment.get('measured_capability')}</p>
								</div>
								<div className="detail-card">
									<h2>Assessment List</h2>
									<div className="assessment-list">
									{
										assessment.get('sections') && assessment.get('sections').map((section, index) => (
											<div key={index} className='assessment-item'>
												<span className="item-title">{section.get('title')}</span>
												<div className="item-details">
													<span>{section.get('type')}</span>
													<span>{section.get('total_questions')} Questions</span>
													<span>{section.get('duration')/60} Minutes</span>
												</div>
											</div>
										))
									}
									</div>
								</div>
							</div>
							<div className='col-md-4'>
								<div className="detail-card">
									<div className="test-info-list">
										<span><UilClipboardAlt /> {assessment.get('assessment_type')}</span>
										<span><UilClockThree /> {assessment.get('total_duration')/60} Mins</span>
										<span><UilDesktop /> {assessment.get('question_type')}</span>
										<span><UilRuler /> {assessment.get('test_type')}</span>
										<span><UilEnglishToChinese /> {assessment.get('language')}</span>
									</div>
									<div className="job-tag-container">
										<h4>Job Role</h4>
										<div className="tag-list">
											{
												assessment.get('job_role') && assessment.get('job_role').map((role, idx)=>(<span>{role}</span>))
											}
										</div>
									</div>
									<div className="job-tag-container">
										<h4>Job Level</h4>
										<div className="tag-list">
											{
												assessment.get('job_level') && assessment.get('job_level').map((role, idx)=>(<span>{role}</span>))
											}
										</div>
									</div>
								</div>
								<div className="action-buttons">
									<button className="btn-secondary-red" onClick={this.openTryModal}>Try</button>
									<button className="btn-primary-red" onClick={this.openModal}>Use Now For Free</button>
								</div>
							</div>
						</div>
					</div>
				</section>
				<FooterNew />
				
				<ModalRegister
					isOpen={this.state.isModalOpen}
					onRequestClose={this.closeModal}
					plan="free"
				/>
				{
					question && (
						<ModalTry
							isOpen={this.state.isTryModalOpen}
							onRequestClose={this.closeTryModal}
							question={question}
							handleNextQuestion={this.handleNextQuestion}
							handlePrevQuestion={this.handlePrevQuestion}
							handleSaveAnswer={this.handleSaveAnswer}
							currentQuestionIndex={this.state.currentQuestionIndex}
							totalQuestions={this.props.assessment.get('sample_questions').size}
						/>
					)
				}
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return{ 
		globalGetLanguages:state.globalGetLanguages,
		assessmentId: ownProps.match.params.assessmentId,
		assessment: state.assessment
	}
  
}

const mapDispatchToProps = (dispatch) => {
	return {
		assessmentGetDetail: (assessmentId, filterData) => dispatch(assessmentGetDetail(assessmentId, filterData)),
		assessmentFetchDetail: (assessment) => dispatch(assessmentFetchDetail(assessment)),

	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentDetail)